/**
 * @generated SignedSource<<7a0df39f2813d613464b1cf8b227979a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EmployeeScheduleEditScheduleListItem_scheduleTags$data = ReadonlyArray<{
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"EmployeeScheduleEditScheduleListItemAssignedScheduleType_employeeScheduleType">;
  readonly " $fragmentType": "EmployeeScheduleEditScheduleListItem_scheduleTags";
}>;
export type EmployeeScheduleEditScheduleListItem_scheduleTags$key = ReadonlyArray<{
  readonly " $data"?: EmployeeScheduleEditScheduleListItem_scheduleTags$data;
  readonly " $fragmentSpreads": FragmentRefs<"EmployeeScheduleEditScheduleListItem_scheduleTags">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "EmployeeScheduleEditScheduleListItem_scheduleTags",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EmployeeScheduleEditScheduleListItemAssignedScheduleType_employeeScheduleType"
    }
  ],
  "type": "EmployeeScheduleType",
  "abstractKey": null
};

(node as any).hash = "9ab3bf053c93f77b688b0823b96bc94c";

export default node;
